export default __webpack_public_path__ + "static/media/dropdown.23d3bb7f.svg";